// extracted by mini-css-extract-plugin
module.exports = {"extraClass":"Canvas_extraClass__2bNuh","canvasImage":"Canvas_canvasImage__r7g-f"};